import '../../utils/polyfills'

import keyboardFocus from 'keyboard-focus'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'

import { BodyScrollBlocker, BodyScrollToTop, DefaultHead, Footer, Header, Layout, Sidebar } from '../../components'
import { actions as AppActions, selectors as AppSelectors } from '../../redux/app/redux'
import router from '../../router'
import { fonts, reset } from '../../theme'
import { localize } from '../../utils/TranslationUtils'
import { getCanonicalURL } from '../../utils/URLUtils'
import routes from '../../router/routes'
import { routesInfos } from '../../root/App/constants'
import { transformDomainRoutes } from '../../helpers/RouteHelpers'
import { ParallaxProvider } from 'react-scroll-parallax'



const mapSelectors = state => ({
  statusCode: 200,
  isNavOpen: AppSelectors.isNavOpen(state),
})

const mapActions = dispatch => ({
  initApp: () => dispatch(AppActions.init()),
  setNavOpen: isNavOpen => dispatch(AppActions.setNavOpen(isNavOpen)),
})

@localize
@connect(mapSelectors, mapActions)
class App extends React.PureComponent {

  static propTypes = {
    initApp: PropTypes.func.isRequired,
    statusCode: PropTypes.number.isRequired,
    activeRoute: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    isNavOpen: PropTypes.bool.isRequired,
    setNavOpen: PropTypes.func.isRequired,
    domains: PropTypes.array,
    t: PropTypes.func.isRequired,
    p: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  }

  componentWillMount = () => {
    const { initApp } = this.props

    initApp()
  }

  componentDidMount() {
    keyboardFocus(document)
  }

  handleClickHeaderButton = () => {
    this.props.setNavOpen(true)
  }

  handleClickSidebarClose = () => {
    this.props.setNavOpen(false)
  }

  renderScrollBlocker() {
    const { isNavOpen } = this.props

    if (isNavOpen) {
      return <BodyScrollBlocker />
    }
  }

  renderErrorPage() {
    return null
  }

  renderPage() {
    // Keep following unused variables, they are for removing unwanted props given to children
    // eslint-disable-next-line
    const { initApp, t, children, ...otherProps } = this.props

    return React.cloneElement(children, otherProps)
  }

  renderFooter() {
    // eslint-disable-next-line
    const { t, locale } = this.props

    return (
      <Footer
        niceCity={t('bbsNiceCity')}
        nicePhone={t('bbsNicePhone')}
        niceEmail={t('bbsNiceEmail')}
        niceAddress={t('bbsNiceAddress')}
        parisCity={t('bbsParisCity')}
        parisPhone={t('bbsParisPhone')}
        parisEmail={t('bbsParisEmail')}
        parisAddress={t('bbsParisAddress')}
        copyright={t('copyright')}
        certificate={t('bbsCertificate')}
        legalNotice={t('bbsLegalNotice')}
        cookies={t('bbsCookies')}
        locale={locale}
      />
    )
  }

  render() {
    const { isNavOpen, locale, activeRoute, t, p, domains } = this.props

    const routesInfosEnhanced = transformDomainRoutes(domains, locale, activeRoute)

    const otherRoutes = Object.values(routesInfos).map(({ label, link, route }) => {
      const name = t(label)
      const routeParams = { locale }
      const isActiveRoute = route ? router(route, routeParams) === activeRoute : false

      return ({
        route,
        routeParams,
        link,
        name,
        active: isActiveRoute
      })
    })

    const project = p(activeRoute)
    const activeRouteName = routesInfosEnhanced
      .find(route => route.active)?.name || project?.title || 'Route'

    const url = `${process.env.APP_URL}${getCanonicalURL(activeRoute)}`

    return (
      <>
        <DefaultHead />
        <Helmet>
          <meta
            property="og:type"
            content="website"
          />
          <meta
            property="og:url"
            content={url}
          />
          <link
            rel="canonical"
            href={url}
          />
        </Helmet>
        <Header
          buttonLabel={activeRouteName}
          onClickButton={this.handleClickHeaderButton}
          locale={locale}
          t={t}
        />
        <Sidebar
          isOpen={isNavOpen}
          onPressClose={this.handleClickSidebarClose}
          activeRouteName={activeRouteName}
          routes={routesInfosEnhanced}
          otherRoutes={otherRoutes}
        />
        <BodyScrollToTop />
        <ParallaxProvider>
          <Layout>
            {this.renderScrollBlocker()}
            {this.renderErrorPage()}
            {this.renderPage()}
            {this.renderFooter()}
          </Layout>
        </ParallaxProvider>
        <style jsx>{reset}</style>
        <style jsx>{fonts}</style>
      </>
    )
  }

}

export default App
